import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';
import { adminOnlyGuard } from './guards/admin-only.guard';


export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home').then(m => m.HomeComponent)
  },
  {
    path: 'about-website',
    loadComponent: () => import('./about-website/about-website').then(m => m.AboutWebsiteComponent)
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us').then(m => m.AboutUsComponent)
  },
  {
    path: 'services',
    loadComponent: () => import('./service-list/service-list').then(m => m.ServiceListComponent)
  },
  {
    path: 'instructions',
    loadComponent: () => import('./instructions/instructions').then(m => m.InstructionsComponent)
  },
  {
    path: 'application-descriptions',
    loadComponent: () => import('./monuments-permit/application-descriptions/application-descriptions').then(m => m.ApplicationDescriptionsComponent)
  },
  {
    path: 'outbound-application-descriptions',
    loadComponent: () => import('./outbound/application-descriptions/application-descriptions').then(m => m.OutboundApplicationDescriptionsComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login').then(m => m.LoginComponent)
  },
  {
    path: 'registration',
    loadComponent: () => import('./auth/registration/registration').then(m => m.RegistrationComponent)
  },
  {
    path: 'email-confirmation/:confirmationCode',
    loadComponent: () => import('./auth/confirm-email/confirm-email').then(m => m.ConfirmEmailComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./auth/forgot-password/forgot-password').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password-confirmation/:confirmationCode',
    loadComponent: () => import('./auth/reset-password/reset-password').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () => import('./user-notifications/user-notifications.component').then(m => m.UserNotificationsComponent)
  },
  {
    path: 'notifications/:tabIndex',
    canActivate: [authGuard],
    loadComponent: () => import('./user-notifications/user-notifications.component').then(m => m.UserNotificationsComponent)
  },
  {
    path: 'notifications/:id/:applicationDataNumber',
    canActivate: [authGuard],
    loadComponent: () => import('./user-notifications/user-notifications.component').then(m => m.UserNotificationsComponent)
  },
  {
    path: 'outbound-notifications',
    canActivate: [authGuard],
    loadComponent: () => import('./user-notifications/user-notifications.component').then(m => m.UserNotificationsComponent),
    data: { isOutbound: true }
  },
  {
    path: 'outbound-notifications/:id/:applicationDataNumber',
    canActivate: [authGuard],
    loadComponent: () => import('./user-notifications/user-notifications.component').then(m => m.UserNotificationsComponent),
    data: { isOutbound: true }
  },
  {
    path: 'monument-permits',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./monuments-permit/monument-permits/monument-permits').then(m => m.MonumentPermitsComponent)
      },
      {
        path: 'application',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent)
      },
      {
        path: 'link-application/:linkedApplicationDataId',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          linkApplication: true
        }
      },
      {
        path: 'application/edit/:id',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent)
      },
      {
        path: 'application/edit-project/:id',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          editProjectMode: true
        }
      },
      {
        path: 'application/history/:id',
        loadComponent: () => import('./monuments-permit/application-history/application-history').then(m => m.ApplicationHistoryComponent)
      },
      {
        path: 'application/answer/:id',
        loadComponent: () => import('./monuments-permit/application-answer/application-answer').then(m => m.ApplicationAnswerComponent)
      },
      {
        path: 'application/history-answer/:id/:historyId',
        loadComponent: () => import('./monuments-permit/application-answer/application-answer').then(m => m.ApplicationAnswerComponent),
        data: {
          isHistory: true
        }
      },
      {
        path: 'application/view/:id',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent)
      },
      {
        path: 'application/view/:id/:historyId',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent)
      },
      {
        path: 'application/view-last-approved/:id/:lastApprovedVersionId',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          lastApproved: true
        }
      },
      {
        path: 'application/report/:id',
        loadComponent: () => import('./monuments-permit/submit-report/submit-report').then(m => m.SubmitReportComponent)
      },
      {
        path: 'application/submit-report/:id',
        loadComponent: () => import('./monuments-permit/submit-report/submit-report').then(m => m.SubmitReportComponent),
        data: {
          isNew: true
        }
      },
      {
        path: 'application/correct-report/:id',
        loadComponent: () => import('./monuments-permit/submit-report/submit-report').then(m => m.SubmitReportComponent),
        data: {
          isCorrection: true
        }
      },
      {
        path: 'application/history-report/:id/:reportId',
        loadComponent: () => import('./monuments-permit/submit-report/submit-report').then(m => m.SubmitReportComponent),
        data: {
          isHistory: true
        }
      },
      {
        path: 'application/edit-term/:id',
        loadComponent: () => import('./monuments-permit/application-term-change/application-term-change').then(m => m.ApplicationTermChangeComponent)
      },
      {
        path: 'application/termination-request/:id',
        loadComponent: () => import('./monuments-permit/application-termination-request/application-termination-request').then(m => m.ApplicationTerminationRequestComponent)
      },
      {
        path: 'application/estimate-plan-request/:id',
        loadComponent: () => import('./monuments-permit/estimate-plan-request/estimate-plan-request').then(m => m.EstimatePlanRequestComponent)
      },
      {
        path: 'application/estimate-plan-history/:id',
        loadComponent: () => import('./monuments-permit/estimate-plan-history/estimate-plan-history').then(m => m.EstimatePlanHistoryComponent)
      },
      {
        path: 'application/estimate-plan/:requestId',
        loadComponent: () => import('./monuments-permit/estimate-plan-view/estimate-plan-view').then(m => m.EstimatePlanViewComponent)
      },
      {
        path: 'application/estimate-plan-version/:id/:versionId',
        loadComponent: () => import('./monuments-permit/estimate-plan-view/estimate-plan-view').then(m => m.EstimatePlanViewComponent),
        data: {
          isVersion: true
        }
      },
    ]
  },
  {
    path: 'outbounds',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./outbound/outbounds/outbounds').then(m => m.OutboundsComponent)
      },
      {
        path: 'application',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent)
      },
      {
        path: 'application/edit/:id',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent),
        data: {
          editMode: true
        }
      },
      {
        path: 'application/view/:id',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent),
        data: {
          viewMode: true
        }
      },
      {
        path: 'application/view/:id/:historyId',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent),
        data: {
          viewMode: true
        }
      },
      {
        path: 'application/history/:id',
        loadComponent: () => import('./outbound/outbound-application-history/outbound-application-history').then(m => m.OutboundApplicationHistoryComponent),
      },
      {
        path: 'application/answer/:id',
        loadComponent: () => import('./outbound/outbound-application-answer/outbound-application-answer').then(m => m.OutboundApplicationAnswerComponent),
      },
      {
        path: 'application/history-answer/:id/:historyId',
        loadComponent: () => import('./outbound/outbound-application-answer/outbound-application-answer').then(m => m.OutboundApplicationAnswerComponent),
        data: {
          isHistory: true
        }
      },
      {
        path: 'application/edit-term/:id',
        loadComponent: () => import('./outbound/outbound-application-term-change/outbound-application-term-change').then(m => m.OutboundApplicationTermChangeComponent),
      },
    ]
  },
  {
    path: 'admin',
    canActivate: [authGuard, roleGuard],
    loadComponent: () => import('./admin/admin-layout/admin-layout').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'services',
        pathMatch: 'full'
      },
      {
        path: 'services',
        loadComponent: () => import('./admin/admin-services/admin-services').then(m => m.AdminServicesComponent)
      },
      {
        path: 'users',
        canActivate: [adminOnlyGuard],
        loadComponent: () => import('./admin/admin-dashboard/admin-dashboard').then(m => m.AdminDashboardComponent)
      },
      {
        path: 'countries',
        canActivate: [adminOnlyGuard],
        loadComponent: () => import('./admin/countries/countries.component').then(m => m.CountriesComponent)
      },
      {
        path: 'applications',
        loadComponent: () => import('./admin/monuments-permit/applications/applications.component').then(m => m.ApplicationsComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'outbound-applications',
        loadComponent: () => import('./admin/outbound/applications/outbound-applications.component').then(m => m.OutboundApplicationsComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'outbound-applications/view/:id',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent),
        data: {
          isAdmin: true,
          viewMode: true
        }
      },
      {
        path: 'outbound-applications/view/:id/:historyId',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent),
        data: {
          isAdmin: true,
          viewMode: true
        }
      },
      {
        path: 'outbound-applications/view-last-approved/:id/:lastApprovedVersionId',
        loadComponent: () => import('./outbound/application/application').then(m => m.OutboundApplicationComponent),
        data: {
          isAdmin: true,
          lastApproved: true
        }
      },
      {
        path: 'outbound-application/history/:id',
        loadComponent: () => import('./outbound/outbound-application-history/outbound-application-history').then(m => m.OutboundApplicationHistoryComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'outbound-application/history-answer/:id/:historyId',
        loadComponent: () => import('./outbound/outbound-application-answer/outbound-application-answer').then(m => m.OutboundApplicationAnswerComponent),
        data: {
          isAdmin: true,
          isHistory: true
        }
      },
      {
        path: 'application/history/:id',
        loadComponent: () => import('./monuments-permit/application-history/application-history').then(m => m.ApplicationHistoryComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'application/history-answer/:id/:historyId',
        loadComponent: () => import('./monuments-permit/application-answer/application-answer').then(m => m.ApplicationAnswerComponent),
        data: {
          isAdmin: true,
          isHistory: true
        }
      },
      {
        path: 'applications/view/:id',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'applications/view-monitoring/:id',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          isAdmin: true,
          isMonitoring: true
        }
      },
      {
        path: 'applications/view/:id/:historyId',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'applications/view-last-approved/:id/:lastApprovedVersionId',
        loadComponent: () => import('./monuments-permit/application/application').then(m => m.ApplicationComponent),
        data: {
          isAdmin: true,
          lastApproved: true
        }
      },
      {
        path: 'application/report/:id',
        loadComponent: () => import('./monuments-permit/submit-report/submit-report').then(m => m.SubmitReportComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'application/history-report/:id/:reportId',
        loadComponent: () => import('./monuments-permit/submit-report/submit-report').then(m => m.SubmitReportComponent),
        data: {
          isAdmin: true,
          isHistory: true,
        }
      },
      {
        path: 'application/termination-request-view/:id',
        loadComponent: () => import('./monuments-permit/application-termination-request/application-termination-request').then(m => m.ApplicationTerminationRequestComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'application/estimate-plan-request/:id',
        loadComponent: () => import('./admin/monuments-permit/estimate-plan-request/admin-estimate-plan-request').then(m => m.AdminEstimatePlanRequestComponent)
      },
      {
        path: 'application/estimate-plan-history/:id',
        loadComponent: () => import('./monuments-permit/estimate-plan-history/estimate-plan-history').then(m => m.EstimatePlanHistoryComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'application/estimate-plan-change/:requestId',
        loadComponent: () => import('./monuments-permit/estimate-plan-view/estimate-plan-view').then(m => m.EstimatePlanViewComponent),
        data: {
          isAdmin: true,
          canAnswer: true
        }
      },
      {
        path: 'application/estimate-plan/:requestId',
        loadComponent: () => import('./monuments-permit/estimate-plan-view/estimate-plan-view').then(m => m.EstimatePlanViewComponent),
        data: {
          isAdmin: true
        }
      },
      {
        path: 'application/estimate-plan-version/:id/:versionId',
        loadComponent: () => import('./monuments-permit/estimate-plan-view/estimate-plan-view').then(m => m.EstimatePlanViewComponent),
        data: {
          isAdmin: true,
          isVersion: true
        }
      },
      {
        path: 'notifications',
        children: [
          {
            path: '',
            loadComponent: () => import('./admin/notifications-landing/notifications-landing').then(m => m.NotificationsLandingComponent)
          },
          {
            path: 'monument-permits',
            loadComponent: () => import('./admin/notifications/notifications.component').then(m => m.AdminNotificationsComponent)
          },
          {
            path: 'monument-permits/:id/:applicationDataNumber',
            loadComponent: () => import('./admin/notifications/notifications.component').then(m => m.AdminNotificationsComponent)
          },
          {
            path: 'outbound',
            loadComponent: () => import('./admin/outbound/notifications/outbound-notifications.component').then(m => m.OutboundAdminNotificationsComponent)
          },
          {
            path: 'outbound/:id/:applicationDataNumber',
            loadComponent: () => import('./admin/outbound/notifications/outbound-notifications.component').then(m => m.OutboundAdminNotificationsComponent)
          },
        ]
      },
      {
        path: 'notification-templates',
        children: [
          {
            path: '',
            loadComponent: () => import('./admin/notification-templates-landing/notification-templates-landing').then(m => m.NotificationTemplatesLandingComponent)
          },
          {
            path: 'monument-permits',
            loadComponent: () => import('./admin/notification-templates/notification-templates.component').then(m => m.NotificationTemplatesComponent)
          },
          {
            path: 'outbound',
            loadComponent: () => import('./admin/notification-templates/outbound-notification-templates/outbound-notification-templates.component').then(m => m.OutboundNotificationTemplatesComponent)
          }
        ]
      },
    ]
  }
];
